import React from 'react';
import { observer } from 'mobx-react-lite';
import Form from 'mobx-react-form';

import { Grid, Typography } from '@mui/material';

import { RentRollTableColumn } from 'types/underwriting/income-approach';
import RentRollTable from './RentRollTable';

import { formOptions } from 'forms/utils/formOptions';
import { plugins } from 'forms/utils/formPlugins';
import { FormOptions, wrapForm } from 'components/shared/form';
import NumericInput from 'components/shared/inputs/NumericInput';
import { RENT_ROLL_LABELS } from '../../constants';
import { useRootStore } from 'stores/RootStore';
import { rentRollFormFields, rentRollFormHelpers } from './rentRollFormConfig';

const formConfig: FormOptions = {
  fields: rentRollFormFields,
  options: {
    ...formOptions,
    validateOnChange: true,
  },
  plugins,
};

type CommercialRentRollProps = {
  form: Form;
};

const CommercialRentRoll = observer(({ form }: CommercialRentRollProps) => {
  const { underwritingPageStore } = useRootStore();
  const { property } = underwritingPageStore.underwritingData || {};
  const columns: RentRollTableColumn[] = rentRollFormHelpers.getUnitsTableColumns();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6">Commercial Rent Roll</Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <NumericInput
              disabled
              size="small"
              value={property?.commercialUnits ?? 0}
              label={RENT_ROLL_LABELS.NUMBER_OF_COMMERCIAL_UNITS}
            />
          </Grid>
          <Grid item xs={12}>
            <RentRollTable form={form} columns={columns} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
});

export default wrapForm({
  ...formConfig,
})(CommercialRentRoll);
